import { IframelyApi, IframelyEmbedApi } from 'api'
import { identity, memoizeWith } from 'ramda'

const urlIdentity = (url: any) => identity(url)

export const getVideoEmbed = memoizeWith(urlIdentity, url => (
  IframelyEmbedApi.get('/', {
    params: {
      url: encodeURI(url)
    }
  })
))

export const getPreviewCard = memoizeWith(urlIdentity, url => (
  IframelyApi.get('/', {
    params: {
      url: url,
      iframe: 1,
      omit_script: 1,
      media: 1
    }
  })
))
